<template>
     <a-card :bordered="false">
         <a-form class="m-t-10 m-b-20" layout='inline'>
         <a-form-item>
             <a-input-group compact :style="{width:'460px'}">
                 <a-select v-model:value="search.key_type" style="width:150px">
                    <a-select-option value="user_name">用户名称</a-select-option>
                    <a-select-option value="card_name">权益卡名称</a-select-option>
                    <a-select-option value="gift_name">礼品名称</a-select-option>
                    <a-select-option value="store_name">核销门店</a-select-option>
                    <a-select-option value="parent_name">门店所属上级</a-select-option>
                 </a-select>
                 <a-input type="text" style="width:60%" v-model:value="search.keyword" placeholder="请输入关键词进行搜索"></a-input>
             </a-input-group>
         </a-form-item>
         <a-form-item label="核销时间">
            <a-range-picker v-model:value="time" :disabledDate="disabledDate" valueFormat='YYYY-MM-DD' format='YYYY-MM-DD' @change="changeData" />
         </a-form-item>
          <a-form-item >
              <a-button type="primary" @click="search.page=1;initData()">搜索</a-button>
          </a-form-item>
          <a-form-item >
              <a-button type="primary" ghost v-has:writeCardExport="()=>{exportTable()}">导出</a-button>
          </a-form-item>
     </a-form>
     <a-table :pagination='pagination' :loading='loading' bordered rowKey='id' :columns='columns' :data-source='list' class='tableFixBox' :scroll="{ x: 'max-content'}" @change="changePage">
         <template v-slot:gift="{record}">
            <template v-if="record.goods&&record.goods.length!=0">
                <div class="ds-i-b m-r-15" v-for="(item,index) in record.goods" :key="index">
                    <img :src="item.image_url?oss+item.image_url:'@/assets/images/normal.png'" style="width:70px;height:70px;border-radius:5px"/>
                </div>
                <a href="javaScript:;" class="s_c376" v-has:seeMemberCardGoods="()=>{seeMemberInfo(record)}">查看</a>
            </template>
            <template v-else>
                <p>-</p>
            </template>
         </template>
     </a-table>
     </a-card>
      <a-modal :keyboard="false" title="核销礼品" v-model:visible="showGift" centered :width='1000' :footer="null" destroyOnClose>
           <a-table :pagination='false' bordered rowKey='id' :columns='gift_columns' :data-source='gift_list'>
               <template v-slot:gifts="{record}">
                       <img :src="record.image_url?oss+record.image_url:'@/assets/images/normal.png'" style="width:70px;height:70px;border-radius:5px"/>
                       <span class="m-l-15">{{record.goods_name || '无'}}</span>
                 </template>
           </a-table>
      </a-modal>
</template>

<script>
import {writeList} from "@/api/assets";
import { toRefs,reactive,ref, onMounted } from 'vue'
 import { iscode } from "@/utils/app";
  import { message } from "ant-design-vue";
  import moment from 'moment'
  import config from "@/config";
   const oss = config.oss[process.env.VUE_APP_type];
const columns = [
    {
        title: "用户名称",
        dataIndex: "member_name",
         fixed: "left"
    },
    {
        title: "权益卡名称",
        dataIndex: "card_name",
        customRender:({record})=>{
            return record.card_name || '-'
        }
    },
    {
         title: "核销礼品",
        dataIndex: "goods",
        slots: { customRender: "gift" },
    },
    {
        title: "核销时间",
        dataIndex: "receive_time",
    },
     {
        title: "发货类型",
        dataIndex: "delivery_type_text",
    },
     {
        title: "核销门店",
        dataIndex: "write_store_name",
    },
    {
        title: "门店所属上级",
        dataIndex: "dealer_name",
    }
]

const gift_columns = [
     {
        title: "礼品名称",
        dataIndex: "goods_name",
        slots: { customRender: "gifts" },
    },
    {
        title: "规格",
        dataIndex: "sku_sn_name",
         align:'center'
    },
    {
        title: "数量",
        dataIndex: "number",
         align:'center'
    },
]
export default{
    setup(){
        const search = ref({
            key_type:'user_name',
            keyword:'',
             start_time: "",
              end_time: "", 
              page: 1,
              limit: 10,
        })
        const state = reactive({
            time:[],
            loading:false,
            list:[],
            gift_list:[],
             pagination:{ //分页
              total:0,
              current:1,
              pageSize:10,
               defaultPageSize:10,
               showSizeChanger:true, 
               pageSizeOptions:['5','10', '20', '30', '40', '50'], 
               showQuickJumper:true, 
               showTotal:(total)=> `共 ${total} 条`
             },
             showGift:false,
             disabledDate:function(date){
                 return date && date > moment().subtract(0, "days")
             }
        })
        const methods= {
            changeData(e){
                search.value.start_time = e[0];
                search.value.end_time = e[1];
                console.log(search)
            },
            changePage(e){
                 state.pagination.pageSize = e.pageSize;
                 state.pagination.current = e.current;
                 search.value.limit = e.pageSize;
                 search.value.page = e.current;
                 methods.initData()
            },
            seeMemberInfo(record){
                console.log(record)
                state.gift_list = record.goods || [];
                state.showGift = true;
            },
        async initData(){
                state.loading = true;
                state.list = [];
                let result = await writeList({...search.value}).then(res=>res.data);
                state.loading = false;
                if(iscode(result)){
                   state.list = result.data.data;
                   state.pagination.total = result.data.total
                }else{
                    message.error(result.msg)
                }
            },
       async exportTable(){
               const hide = message.loading('正在加载中...', 0);
               let result = await writeList({...search.value,excel:1}).then(res=>res.data).catch(error=>error);
               if(iscode(result,true)){
                 window.open(result.data.action)
               }
               setTimeout(hide);
             }
        }
        onMounted(()=>{
            methods.initData()
        })
        return{
            ...toRefs(state),
            search,
            ...methods,
            columns,
            gift_columns,
            oss
        }
    }
}
</script>
